import Branding from "./Branding";
import SettingsNavbar from "./Layout/navbar";
import Messages from "./Messages";
import WebChat from "./Chat";
import SettingTags from "./Tags";
import GuestBook from "./GuestBook";
import DestinationGuide from "./DestinationGuide";
import FiveStarReview from "./FiveStarReview";
import Embed from "./Embed";
import API from "./API";

const Settings = () => {
  return (
    <section id="hms-settings-template">
      <div id="hms-page-title">
        <h1 className="uk-heading-small">Settings</h1>
      </div>
      <div id="hms-main-body">
        <div className="uk-width-1-1@s uk-grid" uk-grid>
          <SettingsNavbar />
          <div className="uk-width-expand hms-left-tabs-content">
            <ul id="settings-tab-left" className="uk-switcher">
              <Branding />
              <Messages />
              <WebChat />
              <GuestBook />
              <DestinationGuide />
              <FiveStarReview />
              <SettingTags />
              <Embed />
              <API />
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
